import React from "react";

const SimpleTableItem = ({
  props,
  subTextPropKey,
  textPropKey,
  urlPropKey
}) => {
  const label = Array.isArray(props[textPropKey])
    ? <>{props[textPropKey].map((label) => <div className="body-medium-regular">{label}</div>)}</>
    : props[textPropKey];
  return (
    <div>
      <div
        className={`${!!props[subTextPropKey] ? "body-medium-semibold" : "body-medium-regular" }`}
      >
        {urlPropKey ? (
          <a
            className="body-medium-semibold"
            href={props[urlPropKey]}
          >
            {label}
          </a>
        ) : (
          label
        )}
      </div>
      <div
        className="body-medium-regular"
      >
        {props[subTextPropKey]}
      </div>
    </div>
  );
};

export default SimpleTableItem;